import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    companies() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`consolidasi/company`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    downloadtemplate() {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await axios({
                    url: `/download/tb-upload`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });        
    },
    kertaskerja(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/consoltbunit/kertaskerja${str}`;
                const {data}= await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    kertaskerjaexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/consoltbunit/kertaskerjaexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },    
    getdata(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['compcode', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/consoltbunit/${str}`;
                const {data}= await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    getfromerp(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['compcode', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/consoltbunit/getfromerp${str}`;
                const {data}= await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    getfromerpconsolidated(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['compcode', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/consoltbunit/getfromerpconsolidated${str}`;
                const {data}= await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    uploadtb(fileXlsx,obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', fileXlsx, fileXlsx.name);
                // const keys = ['sheetName', 'startRow', 'invoiceno', 'CustCode', 'CustName', 'Address1', 'npwp','npwp_name'];
                for (const key in obj) {

                    // if (keys.indexOf(key) >= 0 && obj[key]) {
                        fd.append(key, obj[key]);
                    // }
                }

                const resp = await axios.post("consoltbunit/uploadtb", fd);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    unlockperiode(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post("consoltbunit/unlockperiode", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    exportxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['compcode','company', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/consoltbunit/export${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });

    },

};